var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-609f55dd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"img":"src","image":"xlink:href","b-img":"src","b-img-lazy":["src","blank-src"],"b-card":"img-src","b-card-img":"img-src","b-carousel-slide":"img-src","b-embed":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 